import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { QualityBoostQueuePage } from "./quality-boost-queue";

@NgModule({
  declarations: [QualityBoostQueuePage],
  imports: [
    IonicPageModule.forChild(QualityBoostQueuePage),
    TranslateModule.forChild(),
  ],
})
export class QualityBoostQueuePageModule {}



// WEBPACK FOOTER //
// ./src/pages/quality-boost-queue/quality-boost-queue.module.ts